import styled from 'styled-components';


export const STDPage = styled.div`
    display: grid;
    -webkit-box-align: center;
    align-items: center;
    grid-template-columns: repeat(24, 4.16667%);
    pointer-events: auto;
    grid-template-rows: 12px 1fr 12px;
`;






